import { Capacitor } from '@capacitor/core';

type CapacitorBridge = {
  isNativePlatform: () => boolean;
  getPlatform: () => string;
};

function getCapacitorBridge(): CapacitorBridge {
  const injected = typeof window !== 'undefined'
    ? (window as Window & { Capacitor?: Partial<CapacitorBridge> }).Capacitor
    : undefined;

  return {
    isNativePlatform: injected?.isNativePlatform ?? Capacitor.isNativePlatform,
    getPlatform: injected?.getPlatform ?? Capacitor.getPlatform,
  };
}

export function isNativePlatformRuntime(): boolean {
  return getCapacitorBridge().isNativePlatform();
}

export function isAppleNativeRuntime(): boolean {
  const capacitor = getCapacitorBridge();
  return capacitor.isNativePlatform() && capacitor.getPlatform() === 'ios';
}